// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMMenu.tsx — PropelMapper dropdown / popover menu.
//
// A trigger pill + a floating panel of options. Supports single-select (closes
// on pick) and multi-select (`multi`, stays open, shows a count on the trigger),
// an optional sticky search field (`searchable`), and per-option color dots /
// PropelMapper custom icons (window.PM_ICONS; Material ligature fallback). Closes on outside-click and Escape. All --pm-* tokens;
// focus + open states use --pm-focus-ring.

const PMMENU_CSS = `
.pmmenu{position:relative;display:inline-block;font-family:var(--pm-font-sans)}
.pmmenu-btn{box-sizing:border-box;display:inline-flex;align-items:center;gap:9px;border:1px solid var(--pm-border);background:var(--pm-surface);border-radius:var(--pm-radius-pill,999px);min-height:42px;padding:0 14px;font:var(--pm-label-l);font-weight:600;color:var(--pm-fg-1);cursor:pointer;font-family:inherit;white-space:nowrap}
.pmmenu-btn:hover{border-color:var(--pm-border-dark)}
.pmmenu.is-open .pmmenu-btn{border-color:var(--pm-primary);box-shadow:var(--pm-focus-ring)}
.pmmenu-btn.is-active{background:var(--pm-primary-surface);border-color:var(--pm-primary-light);color:var(--pm-primary-dark)}
.pmmenu-lead{color:var(--pm-fg-3)}
.pmmenu-btn.is-active .pmmenu-lead{color:var(--pm-primary)}
.pmmenu-count{font:var(--pm-pill);background:var(--pm-primary);color:#fff;border-radius:999px;padding:1px 7px}
.pmmenu-caret{color:var(--pm-fg-3);margin-left:1px;transition:transform .15s}
.pmmenu.is-open .pmmenu-caret{transform:rotate(180deg)}
.pmmenu-pop{position:absolute;top:calc(100% + 8px);z-index:60;background:var(--pm-surface);border:1px solid var(--pm-border);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-l,0 12px 32px rgba(0,0,0,.14));padding:8px;min-width:240px;max-height:340px;overflow-y:auto}
.pmmenu-pop.align-left{left:0}
.pmmenu-pop.align-right{right:0}
.pmmenu-search{position:sticky;top:0;background:var(--pm-surface);display:flex;align-items:center;gap:8px;padding:2px 4px 8px;border-bottom:1px solid var(--pm-border-light);margin-bottom:4px}
.pmmenu-search-ic{color:var(--pm-fg-3)}
.pmmenu-search input{flex:1;min-width:0;border:1px solid var(--pm-border);background:var(--pm-surface-variant);border-radius:var(--pm-radius-m,8px);padding:8px 11px;font:var(--pm-body-m);color:var(--pm-fg-1);outline:none;font-family:inherit}
.pmmenu-search input:focus{background:var(--pm-surface);border-color:var(--pm-primary);box-shadow:var(--pm-focus-ring)}
.pmmenu-opt{box-sizing:border-box;display:flex;align-items:center;gap:10px;padding:9px 11px;border-radius:var(--pm-radius-m,8px);cursor:pointer;font:var(--pm-body-m);font-weight:500;color:var(--pm-fg-1);border:none;background:none;width:100%;text-align:left;font-family:inherit}
.pmmenu-opt:hover{background:var(--pm-primary-surface)}
.pmmenu-opt.is-sel{background:var(--pm-primary-surface);color:var(--pm-primary-dark);font-weight:600}
.pmmenu-opt-dot{width:10px;height:10px;border-radius:50%;flex:0 0 10px}
.pmmenu-opt .lead{color:var(--pm-fg-3)}
.pmmenu-opt-name{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pmmenu-check{color:var(--pm-primary);visibility:hidden}
.pmmenu-opt.is-sel .pmmenu-check{visibility:visible}
.pmmenu-empty{padding:14px 11px;text-align:center;font:var(--pm-body-s);color:var(--pm-fg-3)}
`;
function pmmenuEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmmenu-css")) return;
  const s = document.createElement("style"); s.id = "pmmenu-css"; s.textContent = PMMENU_CSS;
  document.head.appendChild(s);
}

const pmmenuGlyphVars: any = { "--icon-fg": "currentColor", "--icon-accent": "currentColor" };
function pmmenuGlyph(base, size, cls = "") {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base] ? base : (I[base + "-outline"] ? base + "-outline" : null);
  if (name) return <span className={"pm-icon " + cls} aria-hidden="true"
    style={Object.assign({ width: size, height: size }, pmmenuGlyphVars)}
    dangerouslySetInnerHTML={{ __html: I[name] }} />;
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 1 }}>{base}</span>;
}

export function PMMenu({
  label,
  icon,
  options = [],
  value,
  multi = false,
  searchable = false,
  onChange,
  placeholder = "Search…",
  align = "left",
  emptyText = "No matches",
  className = "",
  style = {},
  ...rest
}) {
  pmmenuEnsureCSS();
  const [open, setOpen] = React.useState(false);
  const [q, setQ] = React.useState("");
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [open]);

  const norm = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  const isSel = (v) => (multi ? Array.isArray(value) && value.indexOf(v) >= 0 : value === v);
  const filtered = searchable && q
    ? norm.filter((o) => String(o.label).toLowerCase().indexOf(q.toLowerCase()) >= 0)
    : norm;
  const count = multi && Array.isArray(value) ? value.length : 0;
  const selectedSingle = !multi && value != null ? (norm.filter((o) => o.value === value)[0] || {}).label : null;
  const active = multi ? count > 0 : value != null;

  const choose = (v) => {
    if (multi) {
      const arr = Array.isArray(value) ? value.slice() : [];
      const i = arr.indexOf(v);
      if (i >= 0) arr.splice(i, 1); else arr.push(v);
      onChange && onChange(arr);
    } else {
      onChange && onChange(v);
      setOpen(false);
    }
  };

  return (
    <div className={"pmmenu" + (open ? " is-open" : "") + (className ? " " + className : "")} ref={ref} style={style} {...rest}>
      <button type="button" className={"pmmenu-btn" + (active ? " is-active" : "")}
        aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        {icon ? pmmenuGlyph(icon, 18, "pmmenu-lead") : null}
        <span>{multi ? label : (selectedSingle != null ? selectedSingle : label)}</span>
        {count > 0 ? <span className="pmmenu-count">{count}</span> : null}
        {pmmenuGlyph("chevron-down", 16, "pmmenu-caret")}
      </button>
      {open ? (
        <div className={"pmmenu-pop align-" + align} role="listbox">
          {searchable ? (
            <div className="pmmenu-search">
              {pmmenuGlyph("search-outline", 18, "pmmenu-search-ic")}
              <input autoFocus value={q} placeholder={placeholder} onChange={(e) => setQ(e.target.value)} />
            </div>
          ) : null}
          {filtered.length ? filtered.map((o) => (
            <button key={o.value} type="button" role="option" aria-selected={isSel(o.value)}
              className={"pmmenu-opt" + (isSel(o.value) ? " is-sel" : "")} onClick={() => choose(o.value)}>
              {o.dot ? <span className="pmmenu-opt-dot" style={{ background: o.dot }} /> : null}
              {o.icon ? pmmenuGlyph(o.icon, 19, "lead") : null}
              <span className="pmmenu-opt-name">{o.label}</span>
              {pmmenuGlyph("check", 15, "pmmenu-check")}
            </button>
          )) : <div className="pmmenu-empty">{emptyText}</div>}
        </div>
      ) : null}
    </div>
  );
}
